import React from "react";

const NewTabIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.40262 1.32986C1.93397 0.798511 2.65464 0.5 3.40609 0.5H7.18386C7.70547 0.5 8.12831 0.922842 8.12831 1.44444C8.12831 1.96605 7.70547 2.38889 7.18386 2.38889H3.40609C3.1556 2.38889 2.91538 2.48839 2.73826 2.66551C2.56115 2.84263 2.46164 3.08285 2.46164 3.33333V14.6667C2.46164 14.9171 2.56115 15.1574 2.73826 15.3345C2.91538 15.5116 3.15561 15.6111 3.40609 15.6111H14.7394C14.9899 15.6111 15.2301 15.5116 15.4072 15.3345C15.5844 15.1574 15.6839 14.9171 15.6839 14.6667V10.8889C15.6839 10.3673 16.1067 9.94444 16.6283 9.94444C17.1499 9.94444 17.5728 10.3673 17.5728 10.8889V14.6667C17.5728 15.4181 17.2742 16.1388 16.7429 16.6701C16.2115 17.2015 15.4909 17.5 14.7394 17.5H3.40609C2.65464 17.5 1.93397 17.2015 1.40262 16.6701C0.871265 16.1388 0.572754 15.4181 0.572754 14.6667V3.33333C0.572754 2.58189 0.871265 1.86122 1.40262 1.32986ZM11.9061 2.38889C11.3845 2.38889 10.9616 1.96605 10.9616 1.44444C10.9616 0.922842 11.3845 0.5 11.9061 0.5H16.6283C17.1499 0.5 17.5728 0.922842 17.5728 1.44444V6.16667C17.5728 6.68827 17.1499 7.11111 16.6283 7.11111C16.1067 7.11111 15.6839 6.68827 15.6839 6.16667V3.72454L9.74058 9.66782C9.37175 10.0367 8.77376 10.0367 8.40493 9.66782C8.0361 9.29899 8.0361 8.701 8.40493 8.33218L14.3482 2.38889H11.9061Z"
        fill="#242424"
      />
    </svg>
  );
};

export default NewTabIcon;
